import { CompareMetadata } from '@neptune/compare-domain';

const RUN_GROUP_INDEX_MULTIPLIER = 10_000;

export function orderSelectedEntities<T extends { metadata: CompareMetadata; index: number }>(
  items: Array<T> | Map<unknown, T>,
  isValid: (item: T) => boolean = () => true,
) {
  const result = new Map();

  let max = 0;

  for (const item of items.values()) {
    max = Math.max(max, item.index);
  }

  max += 1;

  for (const item of items.values()) {
    if (isValid(item)) {
      item.metadata.forEach((metadata, key) => {
        const value = result.get(key) ?? 0;

        result.set(
          key,
          Math.max((max - item.index) * RUN_GROUP_INDEX_MULTIPLIER + metadata.index, value),
        );
      });
    }
  }

  return result;
}
